import { toast, ToastOptions } from "react-toastify";
import { Box, Typography } from "@mui/material";
import './CommonToast.css'
import React from "react";

export const showToast = (
  message: string,
  type: "success" | "error" | "info" | "warning" = "info",
  options: ToastOptions = {}
) => {
  toast(message, {
    type,
    autoClose: 10000, // 10 seconds
    position: "top-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options, 
    icon: false
  });
};

//modal two
export const DynamicToastContent = ({
  icon,
  message,
  actionText,
  onActionClick,
}: {
  icon?: string | React.ElementType; 
  message: string;
  actionText?: string;
  onActionClick?: () => void;
}) => {
  return (
    <Box className="toast-container" sx={{ display: "flex", alignItems: "center" }}>
      {icon && typeof icon === "string" ? (
        <img src={icon} alt="Toast Icon" style={{ width: "2rem", height: "2rem", marginRight: "10px" }} />
      ) : (
        icon && React.createElement(icon, { sx: { color: "#9B5CFD", fontSize: "2rem" } })
      )}
      <Box>
        <Typography>{message}</Typography>
        {actionText && onActionClick && (
          <Typography className="toast-text" onClick={onActionClick}>
            {actionText}
          </Typography>
        )}
      </Box>
    </Box>
  );
};



